import axiosInstance from "./axiosInstance";

const unwrapError = (error, fallback) =>
  error.response?.data?.message ||
  error.response?.data?.error ||
  fallback;

export const fetchFinkedaV2Gateways = async () => {
  try {
    const response = await axiosInstance.get(`/api/finkeda/v2/gateways`);
    return {
      success: true,
      data: response?.data?.data || response?.data,
    };
  } catch (error) {
    return { success: false, message: unwrapError(error, "Failed to load V2 gateways") };
  }
};

export const createFinkedaV2Checkout = async (payload) => {
  try {
    const response = await axiosInstance.post(`/api/finkeda/v2/checkout`, payload);
    const data = response?.data?.data || response?.data || {};
    return {
      success: true,
      data,
      message: response?.data?.message || "Checkout created",
      redirectionUrl: data.redirectionUrl || data.redirectUrl || null,
      kycUrl: data.kycUrl || null,
      requiresKyc: Boolean(data.requiresKyc),
      urn: data.urn,
      walletWarning: data.walletWarning || null,
    };
  } catch (error) {
    return { success: false, message: unwrapError(error, "V2 checkout failed") };
  }
};

export const checkFinkedaV2Status = async (orderId) => {
  try {
    const response = await axiosInstance.post(`/api/finkeda/v2/status`, { orderId });
    return {
      success: true,
      data: response?.data?.data || response?.data,
      message: response?.data?.message,
    };
  } catch (error) {
    return { success: false, message: unwrapError(error, "Status check failed") };
  }
};
